/**
 * User: WangMeng
 * Date: 2018-07-17
 * Time: 17:45
 * Desc: 管理诚信不佳
 */

import { fieldAnomaly } from '../../../../../utils/formatter';
import BaseDangerDetail from '../../../common/baseDangerDetail/BaseDangerDetail';

export default class ManagementDishonest extends BaseDangerDetail {
    constructor(props) {
        super(props);
        this.title = '目标公司及高管涉诉情况';
    }

    getColumns = () => {
        return [{
            title: '违规主体类型',
            dataIndex: 'irresubType',
            width: 150,
            render: fieldAnomaly
        }, {
            title: '处分类型',
            dataIndex: 'punishType',
            width: 150,
            render: fieldAnomaly
        }, {
            title: '诉讼概况',
            dataIndex: 'lawsuitInfo',
            render: fieldAnomaly
        }];
    };
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialRiskAnalysis/subComponents/danger/ManagementDishonest.jsx